// AuthPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Login from './login';
import Register from './register';
import { Container, ToggleButton } from './styles.js';

const AuthPage = ({ user, loadingUser }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [searchParams] = useSearchParams();
  
  const navigate = useNavigate();

  const [ codeParam, setCodeParam ] = useState(searchParams.get('code'));
  
  useEffect(()=> {
    window.scrollTo(0,0)
  }, [ ]);

  useEffect(() => {
    // Verifica se 'register' é 'true' e obtém o valor de 'code'
    const registerParam = searchParams.get('register') === 'true';

    if (registerParam) {
      setIsLogin(false);
    }
  }, [searchParams]);

  const toggleForm = () => {
    setIsLogin((prev) => !prev); // Alterna entre login e registro.
  };

  useEffect(()=>{
    if (!loadingUser) {
      if (user?.uid) {
        navigate('/');
      }
    }
  }, [ user, loadingUser ])

  return (
    <Container>
      {isLogin ? <Login loadingUser={loadingUser} /> : <Register codeParam={codeParam} loadingUser={loadingUser} />}
      <ToggleButton onClick={toggleForm}>
        {isLogin ? 'Criar Conta' : 'Fazer Login'}
      </ToggleButton>
    </Container>
  );
};

export default AuthPage;
